var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"v-tooltip",on:{"mouseenter":_vm.show,"mouseleave":_vm.hide}},[_vm._t("default"),_vm._v(" "),_c('div',{staticClass:"v-tooltip__wrapper",class:_vm.wrapperClass,attrs:{"aria-hidden":_vm.hidden}},[_c('div',{staticClass:"v-tooltip__content"},[_vm._t("popover")],2)])],2)
}
var staticRenderFns = []

export { render, staticRenderFns }